exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-author[data-v-17d9cab7]{padding:16px 15px 15px 30px}.dax-search-content .profile-author[data-v-17d9cab7]{padding-left:0!important}", ""]);

// exports
